import {
  useMutation, useQueryClient 
} from '@tanstack/react-query';
import { createRequisition } from '../api';
import type { CreateRequisitionRequest } from '../types';

interface UseCreateRequisitionOptions {
  siteId: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useCreateRequisition({
  siteId,
  onSuccess,
  onError,
}: UseCreateRequisitionOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateRequisitionRequest) =>
      createRequisition(siteId, request),
    onSuccess: () => {
      // Invalidate requisitions queries to refetch
      queryClient.invalidateQueries({ queryKey: ['requisitions', siteId] });
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
}
